import React from "react";
import AppConfig from "../../admin/layout/AppConfig";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import Footer from "./Footer";


interface FullPageLayoutProps {
    children: React.ReactNode;
}


export default function FullPageLayout({ children }: FullPageLayoutProps) {

    return (
        <React.Fragment>
            <div className="flex mb-5"></div>
            {children}
            <div className="flex mb-5"></div>
            <Footer/>
            <AppConfig minimal />
        </React.Fragment>
    );
}
